export default () => ({
  type: 'function',
  processor: 'mustache',
  provider: () => `
<div data-jcs-element="provider__container" class="provider-container" style="display: none;"></div>

<div class="row q-gutter-x-sm q-mb-lg items-center">
  <i class="eva eva-checkmark-circle-2 text-primary text-h5"></i>
  <p class="text-weight-bold">Upload your Driver’s Licence</p>
</div>

<div class="q-mb-md">
  <p>Now we need you to take a selfie!</p>
</div>

<!-- UI for displaying the camera selection -->
<form class="q-mb-md">
  <select data-jcs-element="camera__select" class="control control--select"></select>
</form>

<!-- Dashed primary container -->
<div class="bdr-a-primary bdr-dashed bg-primary-pale rounded-borders-lg q-pa-sm q-mb-lg" data-jcs-element="passive__liveness__step__container">
  <!-- UI for displaying the camera view finder -->
  <div class="help-container relative-position">
    <div class="mx-h rounded-borders-lg relative-position">
      <canvas data-jcs-element="camera__viewfinder" class="camera-viewfinder"></canvas>
      <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay--transparent">
        <div class="loading-animation-container" data-jcs-element="loading-animation" style="display:none">
        </div>
      </div>
    </div>
  </div>
  
  <!-- Caption message -->
  <div class="q-my-md text-weight-medium text-center">
    {{CAMERA_CAPTURE_SELFIE_CAPTION}}
  </div>

  <!-- Button to take the photo -->
  <form class="camera-capture--container bdr-a-primary-lg">
    <input data-jcs-element="camera__capture" class="camera-capture--button bg-primary" type="button" />
  </form>
</div>

<!-- Error notification -->
<div class="notification notification-orange q-mb-lg" data-jcs-element="passive__liveness__message__container" style="display: none;">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M13.9212 13.5664L7.99878 1.70494L1.99909 13.5664H13.9212ZM15.3721 13.1144L9.18082 0.71445C8.95064 0.27521 8.49571 0 7.99982 0C7.50392 0 7.04899 0.27521 6.81882 0.71445L0.546752 13.1144C0.33024 13.5277 0.345567 14.0242 0.587162 14.4234C0.828758 14.8226 1.26147 15.0665 1.72808 15.0664H14.1908C14.6574 15.0665 15.0901 14.8226 15.3317 14.4234C15.5733 14.0242 15.5886 13.5277 15.3721 13.1144ZM7.99976 4.75C8.41397 4.75 8.74976 5.08579 8.74976 5.5V9.5C8.74976 9.91421 8.41397 10.25 7.99976 10.25C7.58554 10.25 7.24976 9.91421 7.24976 9.5V5.5C7.24976 5.08579 7.58554 4.75 7.99976 4.75ZM7.99976 13C8.55204 13 8.99976 12.5523 8.99976 12C8.99976 11.4477 8.55204 11 7.99976 11C7.44747 11 6.99976 11.4477 6.99976 12C6.99976 12.5523 7.44747 13 7.99976 13Z"
      fill="#F88618" />
  </svg>
  <div>
    <p data-jcs-element="passive__liveness__message__title" style="font-weight: bold;"></p>
    <p data-jcs-element="passive__liveness__message"></p>
  </div>
</div>
`
});
